import React from 'react';
import { Phone, Mail, MapPin, Facebook, Instagram } from 'lucide-react';

const footerLinks = [
  {
    title: 'Navigare',
    links: [
      { label: 'Acasă', href: '#hero' },
      { label: 'Despre noi', href: '#despre' },
      { label: 'Servicii', href: '#servicii' },
      { label: 'Proiecte', href: '#proiecte' },
      { label: 'Contact', href: '#contact' },
    ],
  },
  {
    title: 'Servicii',
    links: [
      { label: 'Mobilier bucătărie', href: '#servicii' },
      { label: 'Mobilier living', href: '#servicii' },
      { label: 'Mobilier dormitor', href: '#servicii' },
      { label: 'Mobilier birou', href: '#servicii' },
      { label: 'Mobilier comercial', href: '#servicii' },
    ],
  },
];

export default function Footer() {
  const scrollTo = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer data-testid="footer" className="bg-[#2C2A29] dark:bg-[#141312] text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16 lg:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12">
          <div className="lg:col-span-1">
            <a
              href="#hero"
              data-testid="footer-logo"
              onClick={(e) => { e.preventDefault(); scrollTo('#hero'); }}
              className="inline-block"
            >
              {/* Option 1: Image logo — place your logo file in /public and update the src */}
              {/* <img src="/logo.png" alt="Mobila ta Mob" className="h-10 w-auto" /> */}

              {/* Option 2: Text logo (current) */}
              <span className="font-['Outfit'] text-2xl font-semibold tracking-tight">
                Mobila ta <span className="text-[#A67B5B]">Mob</span>
              </span>
            </a>
            <p className="text-sm text-white/60 leading-relaxed mt-4 max-w-xs">
              Mobilier personalizat din materiale premium. Transformăm viziunea ta în realitate cu pasiune și profesionalism.
            </p>
            <div className="flex gap-4 mt-6">
              <a
                href="tel:+40738562505"
                data-testid="footer-phone"
                className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#A67B5B] transition-colors"
              >
                <Phone size={16} />
              </a>
              <a
                href="mailto:contact@mobilatamob.ro"
                data-testid="footer-email"
                className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#A67B5B] transition-colors"
              >
                <Mail size={16} />
              </a>
              <a
                href="https://www.facebook.com/mobilatamob"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-facebook"
                className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#A67B5B] transition-colors"
              >
                <Facebook size={16} />
              </a>
              <a
                href="https://www.instagram.com/mobilatamob"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram"
                className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#A67B5B] transition-colors"
              >
                <Instagram size={16} />
              </a>
              <span
                data-testid="footer-location"
                className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center"
              >
                <MapPin size={16} />
              </span>
            </div>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="font-['Outfit'] font-medium text-base mb-5">{group.title}</h4>
              <ul className="space-y-3">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      onClick={(e) => { e.preventDefault(); scrollTo(link.href); }}
                      className="text-sm text-white/60 hover:text-[#A67B5B] transition-colors"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

            <div>
            <h4 className="font-['Outfit'] font-medium text-base mb-5">Contact</h4>
            <div className="space-y-3 text-sm text-white/60">
              <a href="tel:+40738562505" className="block hover:text-[#A67B5B] transition-colors">+40 738 562 505</a>
              <a href="mailto:contact@mobilatamob.ro" className="block hover:text-[#A67B5B] transition-colors">contact@mobilatamob.ro</a>
              <p>Strada Nicolae Labiș nr. 114,<br />Dumbrăveni, jud. Suceava</p>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/40">
            &copy; {new Date().getFullYear()} Mobila ta Mob. Toate drepturile rezervate.
          </p>
          <p className="text-xs text-white/40">
            Mobilier personalizat la comandă &mdash; Dumbrăveni, Suceava, România
          </p>
        </div>
      </div>
    </footer>
  );
}
